import { Component, Input, OnInit } from '@angular/core';
import { PageElementViewModel, ConferenceViewModel, CourseSearchParameters, CourseViewModel, CourseViewModelSimple } from 'src/app/_models/generatedModels';
import { CourseService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'bxl-conference-on-demand-listing',
  templateUrl: 'conference-on-demand-listing.component.html',
})
export class ConferenceOnDemandListingComponent implements OnInit {
  initialized = false;
  @Input() conference: ConferenceViewModel;
  @Input() element: PageElementViewModel;
  anyOnDemand: boolean;
  courses: CourseViewModelSimple[];

  constructor(private courseService: CourseService) {}

  ngOnInit(): void {
    var params = new CourseSearchParameters();
    params.conferenceId = this.conference.id;
    params.page = 0;
    params.pageSize = 10000;

    this.courseService.search(params).subscribe((result) => {
      this.courses = result.courses;
      this.initialized = true;
    });
  }
}
